<template>
  <div>
    <vx-card>
      <List :subjectPermission="subjectPermission"></List>
    </vx-card>
  </div>
</template>

<script>
import List from "./ListFaq";

export default {
  data() {
    return {
      subjectPermission: "Faq",
    };
  },
  methods: {},
  components: {
    List,
  },
};
</script>
